<span>{{ addonLeft }}</span>
<ng-container *ngIf="!displayWith; else displayWithTemp">
  <ng-container [ngSwitch]="type">
    <span *ngSwitchCase="'address'">{{ value | address }}</span>
    <span *ngSwitchCase="'date'">{{ value | date : 'shortDate' }}</span>
    <span *ngSwitchCase="'date-range-picker'">
      {{ value.dateFrom | date : 'shortDate' }} -
      {{ value.dateTo | date : 'shortDate' }}
    </span>
    <span *ngSwitchCase="'select'">{{ value | matchingLabel : options }}</span>
    <span *ngSwitchCase="'currency'">{{
      value | number : decimalFormat || '1.2'
    }}</span>
    <span *ngSwitchCase="'summary'">{{
      value | number : decimalFormat || '1.2'
    }}</span>
    <ul *ngSwitchCase="'file'">
      <li *ngFor="let file of value" class="d-flex mb-1">
        <a
          style="pointer-events: all"
          class="d-flex align-items-center"
          [href]="file.src"
          [download]="file.name"
        >
          <span
            class="dynamic-cell__document-icon d-flex d-print-none justify-content-center align-items-center me-1"
          >
            <mat-icon svgIcon="document_thin"></mat-icon>
          </span>
          {{ $any(file).name }}
        </a>
      </li>
    </ul>
    <ul *ngSwitchCase="'file-input'">
      <li *ngFor="let file of value" class="d-flex mb-1">
        <ng-container *ngIf="file.src; else emitTemplate">
          <a
            style="pointer-events: all"
            class="d-flex align-items-center"
            [href]="file.src"
            [download]="file.name"
          >
            <span
              class="dynamic-cell__document-icon d-flex d-print-none justify-content-center align-items-center me-1"
            >
              <mat-icon svgIcon="document_thin"></mat-icon>
            </span>
            {{ $any(file).name }}
          </a>
        </ng-container>
        <ng-template #emitTemplate>
          <a
            style="pointer-events: all"
            class="d-flex align-items-center"
            (click)="
              customEvent.emit({
                name: 'download',
                value: { fileId: file.fileId, fileName: file.name }
              })
            "
          >
            <span
              class="dynamic-cell__document-icon d-flex d-print-none justify-content-center align-items-center me-1"
            >
              <mat-icon svgIcon="document_thin"></mat-icon>
            </span>
            {{ $any(file).name }}
          </a>
        </ng-template>
      </li>
    </ul>
    <span *ngSwitchDefault>{{ value || value === 0 ? value : '-' }}</span>
  </ng-container>
</ng-container>

<ng-template #displayWithTemp>{{
  displayWith(value, parentValue)
}}</ng-template>

<span class="ms-_5">{{ addonRight }}</span>
